<template>
  <header class="console-header">
    <div class="header-title">
      <h1>
        <span v-if="isShowBack" class="back-btn" @click="openHome">
          <el-icon><Back /></el-icon>
        </span>
        {{ headerTitle }}
        <span class="live-badge">
          <div class="dot"></div>
          System Online
        </span>
      </h1>
    </div>
    <div class="header-stats">
      <template v-if="isLoggedIn">
        <div class="stat-item" @click="openPersonalCenter" style="cursor: pointer;">
          可用点数 <span class="stat-value power-value">{{ userPower }}</span>
        </div>
        <div class="stat-item" @click="contactCustomer" style="cursor: pointer;">
          <i class="fa-solid fa-headset"></i>
        </div>
        <!--
        <div class="stat-item" @click="openInviteGift" style="cursor: pointer;">
          <i class="fa-solid fa-gift"></i>
        </div>
        -->
      </template>
      <template v-else>
        <el-button type="primary"  @click="handleLogin">登录</el-button>
      </template>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { Coin, Back, Present, User } from '@element-plus/icons-vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessageBox } from 'element-plus'
import { getAgentInfo } from '@/stores/portal/agentStore'
import { getPathWithAgent } from '@/apps/portal/utils/agentUtils'
import defaultQrImg from '@/apps/portal/assets/qr.jpg'

const router = useRouter()
const route = useRoute()

const props = defineProps({
  userPower: {
    type: Number,
    default: 0
  },
  isShowBack: {
    type: Boolean,
    default: false
  },
  headerTitle: {
    type: String,
    default: 'AI 任务控制台'
  }
})

const isLoggedIn = computed(() => {
  return !!localStorage.getItem('token')
})

// 获取响应式的代理信息
const agentInfo = getAgentInfo()

// 动态Logo和客服二维码 - 使用computed实现响应式
const logoUrl = computed(() => {
  return agentInfo.logo || defaultLogo
})

const qrCodeUrl = computed(() => {
  return agentInfo.qrcode || defaultQrImg
})

const handleLogin = () => {
  // 跳转到登录页面时保留agent参数
  const loginPath = getPathWithAgent('/login')
  router.push(loginPath)
}

// 获取基础路径，兼容测试和正式环境
const getBasePath = () => {
  const base = import.meta.env.VITE_APP_BASE_URL || '/'
  // 移除末尾的斜杠（如果有），因为路径已经以 / 开头
  return base.endsWith('/') ? base.slice(0, -1) : base
}

const openInviteGift = () => {
  const basePath = getBasePath()
  window.open(`${basePath}/inviteGift`, '_blank')
}

const openHome = () => {
  const basePath = getBasePath()
  // 如果当前在任务详情页面，返回时显示我的任务页面
  if (route.path === '/task/detail') {
    window.open(`${basePath}/home?view=myTasks`, '_self')
  } else {
    window.open(`${basePath}/home`, '_self')
  }
}

const openPersonalCenter = () => {
  const basePath = getBasePath()
  window.open(`${basePath}/personalCenter`, '_self')
}

const openServiceTerms = () => {
  const basePath = getBasePath()
  window.open(`${basePath}/terms`, '_blank')
}

const openPrivacyPolicy = () => {
  const basePath = getBasePath()
  window.open(`${basePath}/privacy`, '_blank')
}

// 联系客服
const contactCustomer = () => {
  ElMessageBox.alert(
    `<div style="text-align: center;">
      <img src="${qrCodeUrl.value}" alt="客服二维码" style="width: 200px; height: 272px; margin-bottom: 16px;" />
      <p style="color: #666; font-size: 14px;">扫描二维码联系客服</p>
    </div>`,
    '联系客服',
    {
      confirmButtonText: '关闭',
      dangerouslyUseHTMLString: true,
      customClass: 'customer-service-dialog',
      center: true
    }
  )
}

defineExpose({
  openInviteGift
})
</script>

<style scoped>
.console-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  margin-top: 0;
  padding-bottom: 20px;
  border-bottom: 1px solid #F3F4F6;
  flex-shrink: 0;
}

.header-title h1 {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary, #1F2937);
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
}

.back-btn {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: var(--text-secondary, #6B7280);
  transition: color 0.2s;
}

.back-btn:hover {
  color: var(--text-brand, #4F46E5);
}

.live-badge {
  font-size: 12px;
  background: #ECFDF5;
  color: #059669;
  padding: 4px 8px;
  border-radius: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.dot {
  width: 6px;
  height: 6px;
  background: #10B981;
  border-radius: 50%;
}

.header-stats {
  display: flex;
  gap: 12px;
  align-items: center;
}

.stat-item {
  font-size: 13px;
  color: var(--text-secondary, #6B7280);
  background: #F9FAFB;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.stat-item:hover {
  background: #F3F4F6;
  border-color: #D1D5DB;
}

.stat-item i {
  font-size: 14px;
  color: var(--text-secondary, #6B7280);
}

.stat-value {
  font-weight: 600;
  color: var(--text-primary, #1F2937);
  margin-left: 6px;
}

.stat-value.power-value {
  color: #F59E0B;
}

.stat-item-btn {
  font-size: 13px;
  color: var(--text-secondary, #6B7280) !important;
  background: #F9FAFB !important;
  padding: 8px 12px !important;
  border-radius: 8px !important;
  border: 1px solid #E5E7EB !important;
  transition: all 0.2s;
  height: auto !important;
}

.stat-item-btn:hover {
  background: #F3F4F6 !important;
  border-color: #D1D5DB !important;
  color: var(--text-secondary, #6B7280) !important;
}

.font {
  font-size: 13px;
}
/* 客服对话框样式 */
:deep(.customer-service-dialog) {
  background: #262626;
  border: 1px solid #3b3b3b;
}

:deep(.customer-service-dialog .el-message-box__header) {
  background: #1e1e1e;
  border-bottom: 1px solid #3b3b3b;
}

:deep(.customer-service-dialog .el-message-box__title) {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}

:deep(.customer-service-dialog .el-message-box__content) {
  background: #262626;
  color: #fff;
  padding: 24px;
}

:deep(.customer-service-dialog .el-message-box__btns) {
  background: #1e1e1e;
  border-top: 1px solid #3b3b3b;
  padding: 16px 24px;
}

:deep(.customer-service-dialog .el-button) {
  background: #409EFF;
  border-color: #409EFF;
  color: #fff;
}

:deep(.customer-service-dialog .el-button:hover) {
  background: #66b1ff;
  border-color: #66b1ff;
}
</style>
